import { render, staticRenderFns } from "./CalendarPlaceWork.vue?vue&type=template&id=1f0a891b&"
import script from "./CalendarPlaceWork.vue?vue&type=script&lang=js&"
export * from "./CalendarPlaceWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCalendar } from 'vuetify/lib/components/VCalendar';
installComponents(component, {VCalendar})
